import { useUserApi } from '@/features/users';
import type { IShipmentTrackingInfo } from '@/types';
import { useCallback, useEffect, useRef, useState } from 'react';

interface IUseFetchTrackingInfoReturnValue {
  fetch: (id: string) => void;
  hasError: boolean;
  isLoading: boolean;
  trackingInfo?: IShipmentTrackingInfo;
}

export const useFetchTrackingInfo = (id: string): IUseFetchTrackingInfoReturnValue => {
  const userApi = useUserApi();
  const [trackingInfo, setTrackingInfo] = useState<IShipmentTrackingInfo | undefined>();
  const ref = useRef(false);
  const [state, setState] = useState({ isLoading: false, hasError: false });

  const fetchTrakingInfo = useCallback(() => {
    if (!ref.current) {
      ref.current = true;
      setState({ isLoading: true, hasError: false });

      void (async (): Promise<void> => {
        try {
          const res = await userApi.getShipmentHistory(id);
          setTrackingInfo(res);
          setState({ isLoading: false, hasError: false });
        } catch (error) {
          console.error(error);
          setState({ isLoading: false, hasError: true });
        } finally {
          ref.current = false;
        }
      })();
    }
  }, [userApi, id]);

  useEffect(fetchTrakingInfo, [fetchTrakingInfo]);

  return { trackingInfo, ...state, fetch: () => fetchTrakingInfo() };
};
